export default __webpack_public_path__ + "static/media/lil-nouners-bg-mobile.e2b9bda2.png";